import { render } from "./BackstageGalleryManager.vue?vue&type=template&id=c74224f4&scoped=true"
import script from "./BackstageGalleryManager.vue?vue&type=script&lang=js"
export * from "./BackstageGalleryManager.vue?vue&type=script&lang=js"

import "./BackstageGalleryManager.vue?vue&type=style&index=0&id=c74224f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74224f4"]])

export default __exports__